import { SxProps } from '@mui/material';

const DialogActionsStyles: SxProps = {
	padding: '0.5rem 1.5rem 1.5rem 1.5rem',
};

export default {
	dialog_actions: DialogActionsStyles,
};
